const ruleAndPolicyEn = {
  components: {
    allSubordinatesCard: {
      label: 'All subordinates'
    },
    appliedPeriodRuleSummary: {
      inheritedRuleLabel: 'Inherited Rule'
    },
    dueDate: {
      dueDateType: {
        off: 'Off',
        relativeDate: 'Relative Date',
        specificDate: 'Fixed Date',
        template: 'Template'
      },
      relativeDate: {
        referenceDate: 'Reference date',
        timing: 'Timing',
        timingAfter: 'After Anchor Date',
        timingBefore: 'Before Anchor Date',
        timingOn: 'The Day of Anchor Date',
        unit: 'Unit',
        unitDay: 'Day',
        unitMonth: 'Month',
        unitYear: 'Year',
        validation: {
          referenceDateRequired: 'Select a reference date',
          relativeDateInvalid: 'Check the relative date settings',
          valueRequired: 'Value is required',
          valueTooLarge: 'Value is too large',
          valueTooSmall: 'Value must be 0 or greater'
        },
        value: 'Value'
      },
      sectionHeader: {
        relativeDate: 'Relative Date',
        specificDate: 'Fixed Date',
        template: 'Template'
      },
      sectionTooltip: {
        relativeDate: 'Set a deadline relative to the reference date.',
        specificDate: 'Set a specific date from the calendar.',
        template: 'Set a deadline using a predefined template.'
      },
      specificDate: {
        date: 'Date',
        frequency: 'Frequency',
        frequencyMonth: 'Month',
        frequencyYear: 'Year',
        repeatEvery: 'Repeat Every',
        repeating: 'Repeating',
        repeatingOff: 'Off',
        repeatingOn: 'On'
      }
    },
    organizationUnitSelectorCombobox: {
      placeholder: 'Add organization unit'
    },
    peopleGroupTable: {
      personGroupName: 'Person group name',
      removeGroup: 'Remove group',
      total: 'Total'
    },
    requestTableView: {
      assignmentDate: 'Assignment date',
      deprovisioningDate: 'Deprovisioning date',
      excluded: 'Excluded',
      included: 'Included',
      person: 'Person',
      usagePeriod: 'Usage period'
    },
    ruleCard: {
      title: 'Membership'
    },
    ruleClause: {
      clauseTypeTitle: {
        individual: 'Individual',
        organization: 'Organization',
        peopleGroup: 'People Group',
        request: 'Request',
        workerType: 'Worker Type'
      },
      clauseTypeTooltip: {
        individual: 'You can set conditions for individuals when specifying/excluding ones separately from other conditions.',
        organization: 'Set conditions for each organization unit. You can specify to include all the people in their organization unit and its subordinate organization units.',
        peopleGroup: 'Select people groups that are preconfigured in the permission & roles.',
        request: 'If assigned/unassigned based on a request through operation packages, the conditions automatically are set to include/exclude them.',
        workerType: 'Set conditions for each worker type as shown.'
      },
      editAriaLabel: 'Edit {{title}}',
      helpAriaLabel: '{{title}} help'
    }
  }
};
export default ruleAndPolicyEn;